import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'typeTranslate',
  standalone: true
})
export class TypeTranslatePipe implements PipeTransform {

  private typeMappings: any = {
    'de': {
      'BIOMASS':'Biomasse',
      'ELECTRICITY':'Hauhaltsstrom',
      'ELECTRICITY_HEATGENERATOR_HT':'Wärmeerzeugerstrom Hochtarif',
      'ELECTRICITY_HEATPUMP':'Wärmeerzeugerstrom',
      'ELECTRICITY_HOUSEHOLD_HT':'Haushaltsstrom Hochtarif',
      'GAS':'Gas',
      'HARDWOOD':'Hartholz',
      'HEATING_OIL':'Heizöl',
      'PELLET':'Pellets',
      'SOFTWOOD':'Weichholz',
      'ELECTRICITY_OWN_NEEDS':'Eigenverbrauchsstrom',
      'ELECTRICITY_FEED':'Eingespeister Strom',
    },
    "en": {
      "BIOMASS": "Biomass",
      'ELECTRICITY': 'Household electricity',
      'ELECTRICITY_HEATGENERATOR_HT': 'Heat generator electricity peak rate',
      'ELECTRICITY_HEATPUMP': 'Heat generator electricity',
      'ELECTRICITY_HOUSEHOLD_HT': 'Household electricity peak rate',
      "GAS": "Gas",
      "HARDWOOD": "Hardwood",
      "HEATING_OIL": "Heating oil",
      "PELLET": "Pellets",
      "SOFTWOOD": "Softwood",
      "ELECTRICITY_OWN_NEEDS": "Self-consumed electricity",
      "ELECTRICITY_FEED": "Grid feed-in"
    },
    "be": {
      "BIOMASS": "Biomasse",
      'ELECTRICITY': 'Électricité domestique',
      'ELECTRICITY_HEATGENERATOR_HT': 'Électricité du générateur de chaleur heures pleines',
      'ELECTRICITY_HEATPUMP': 'Électricité du générateur de chaleur',
      'ELECTRICITY_HOUSEHOLD_HT': 'Électricité domestique heures pleines',
      "GAS": "Gaz",
      "HARDWOOD": "Bois dur",
      "HEATING_OIL": "Fioul",
      "PELLET": "Granulés",
      "SOFTWOOD": "Bois tendre",
      "ELECTRICITY_OWN_NEEDS": "Autoconsommation",
      "ELECTRICITY_FEED": "Électricité injectée"
    }
  };

  transform(dbValue: string, countryCode: string = 'en'): string {
    const langDict = this.typeMappings[countryCode] || this.typeMappings['en'];
    return langDict[dbValue] || dbValue;
  }

}
